/** Hjälpinnehåll (sv/en). Vardaglig ton — inga tekniska termer för slutanvändare. */

export const HELP_SECTIONS = {
  sv: [
    {
      title: "Hjälp och regler",
      paragraphs: [
        "Här hittar du en enkel genomgång av hur tipset fungerar, vad du fyller i på de olika sidorna och när dina tips låses. Exakta poäng kan skilja sig mellan olika turneringar, så titta alltid under Inställningar om du vill se vad som gäller i just ert spel.",
      ],
    },
    {
      title: "Vad är det här för spel?",
      paragraphs: [
        "Det här är ett gemensamt tipsspel där du och andra deltagare tippar på matcher, tabeller och extra frågor kring turneringen.",
        "Den som har skapat turneringen bestämmer hur många poäng olika saker ger. Det kan till exempel vara poäng för rätt vinnare i en match, helt rätt resultat, rätt placering i en grupp eller rätt vinnare av hela turneringen.",
        "Du behöver inte räkna ut poängen själv. När riktiga resultat har lagts in räknar appen ut poängen automatiskt.",
      ],
    },
    {
      title: "Gruppspel",
      paragraphs: [
        "Under Gruppspel tippar du resultatet i varje match. Du fyller i hur många mål du tror att hemmalaget gör och hur många mål du tror att bortalaget gör.",
        "Beroende på reglerna i turneringen kan du få poäng för att ha rätt vinnare, rätt oavgjort resultat eller helt rätt slutresultat.",
        "Dina gruppspelstips måste vara ifyllda innan gruppspelet låses. Samma gäller tabelltips och extra tips (finalister, vinnare, skyttekung).",
      ],
    },
    {
      title: "Slutspel",
      paragraphs: [
        "Slutspelet fungerar på ungefär samma sätt som gruppspelet. Du tippar resultat i åttondelsfinaler, kvartsfinaler, semifinaler och final, beroende på hur turneringen är upplagd.",
        "Vissa slutspelsmatcher kan sakna lag i början. Det beror på att lagen inte är klara förrän tidigare matcher eller grupper är färdigspelade. När lagen är klara kan du fylla i dina tips.",
      ],
    },
    {
      title: "Tabeller",
      paragraphs: [
        "Under Tabeller väljer du hur du tror att lagen placerar sig i varje grupp. Vanligtvis väljer du vilket lag som blir etta, tvåa och trea.",
        "Tabelltipsen låses när den första gruppspelsmatchen startar.",
        "Det här är separata tips och räknas inte som vanliga matchtips. Du kan alltså få poäng både för enskilda matcher och för hur bra du lyckas pricka gruppens slutställning.",
        "I vissa turneringar kan du även få poäng om du valt rätt lag men på fel placering. Exakt hur det fungerar ser du under Inställningar.",
      ],
    },
    {
      title: "Extra tips",
      paragraphs: [
        "Under Extra kan det finnas fler saker att tippa på. Det kan till exempel vara finalister, vinnare av hela turneringen eller skyttekung.",
        "Extra-tipsen låses när den första gruppspelsmatchen startar.",
        "De här tipsen ger egna poäng och räknas separat från matcherna och tabellerna. Vill du se exakt vad varje val är värt hittar du det under Inställningar.",
        "För skyttekung kan reglerna vara olika. I vissa turneringar får du bara poäng om du väljer den spelare som faktiskt blir skyttekung. I andra kan du få poäng för varje mål som en vald spelare gör.",
      ],
    },
    {
      title: "Översikt",
      paragraphs: [
        "På Översikt ser du matcherna i datumordning. Det är en bra sida om du vill få koll på hela spelschemat och snabbt se vilka matcher som kommer härnäst.",
      ],
    },
    {
      title: "Topplistor och jämförelser",
      paragraphs: [
        "På topplistorna ser du hur du ligger till jämfört med andra deltagare i samma turnering.",
        "Det kan också finnas vyer där du kan jämföra hur andra har tippat. Det är till för att ge bättre överblick och göra spelet roligare att följa. Din poäng påverkas bara av dina egna tips och de riktiga resultaten.",
      ],
    },
    {
      title: "Odds som hjälp",
      paragraphs: [
        "På vissa matcher kan du visa odds som stöd när du tippar. Oddsen visar ungefär hur spelbolag eller oddskällor bedömer matchen.",
        "Oddsen är bara tänkta som hjälp. Du spelar inte om pengar i appen och oddsen påverkar inte dina poäng.",
        "Om odds saknas på en match går det ändå bra att tippa manuellt, så länge matchen inte är låst.",
      ],
    },
    {
      title: "Harry Boy",
      paragraphs: [
        "Harry Boy är en snabbfunktion som kan fylla i gruppspelsmatcher åt dig. Den använder de resultatförslag som finns i oddsmaterialet och väljer tips utifrån det.",
        "Det är ett enkelt sätt att komma igång om du inte vill fylla i varje match själv.",
        "Harry Boy fyller bara i gruppspelsmatcher där det finns tillräckligt underlag från oddsen. Om en match saknar sådant underlag hoppar funktionen över den, och då får du fylla i matchen själv.",
        "Om du redan har börjat fylla i en match, till exempel bara hemmalagets mål, kan Harry Boy fylla i det som saknas.",
      ],
    },
    {
      title: "Harry Boys olika lägen",
      bullets: [
        "Målsnålt väljer oftare resultat med få mål, men kan ibland ta ett annat läge eller en närliggande rad.",
        "Målrikt väljer oftare resultat med fler mål, med samma typ av variation.",
        "Säkert väljer oftare favoriten enligt oddsen, med samma typ av variation.",
        "Mix slumpar läge per match och varierar även raden inom läget.",
      ],
      paragraphs: [
        "Harry Boy ändrar inte tabelltips, slutspelstips, finalister, vinnare eller skyttekung. Den används bara för gruppspelsmatcherna.",
        "När gruppspelet är låst går det inte längre att använda Harry Boy.",
      ],
    },
    {
      title: "Rensa och ändra tips",
      paragraphs: [
        "Du kan ändra dina tips fram tills den del av turneringen låses.",
        "Där det finns en rensa knapp kan du ta bort dina ifyllda gruppspelstips och börja om.",
        "När en del är låst går det inte längre att ändra tipsen i den delen. Det gäller alla deltagare på samma sätt.",
      ],
    },
    {
      title: "När låses tipsen?",
      paragraphs: [
        "Alla deltagare i samma turnering följer samma låstider.",
        "Gruppspelet låses när den första gruppspelsmatchen startar. Efter det kan ingen ändra gruppspelsmatcher, tabelltips, extra tips eller använda Harry Boy för gruppspelet.",
        "Slutspelet har en egen låsning. Slutspelstipsen låses när den första slutspelsmatchen startar. Det betyder att du kan ändra slutspelstips även efter att gruppspelet har börjat, så länge slutspelet inte har startat än.",
        "Om en match saknar lag går den inte att tippa på förrän lagen är klara. Det är inte samma sak som att matchen är låst.",
      ],
    },
    {
      title: "Var hittar jag poängen?",
      paragraphs: [
        "Poängen kan se olika ut i olika turneringar. Gå till Inställningar i din turnering för att se exakt vad som gäller.",
        "Där ser du hur många poäng du får för matchtips, tabelltips, extra tips, finalister, vinnare, skyttekung och andra regler som arrangören har valt.",
      ],
    },
  ],
  en: [
    {
      title: "Help and rules",
      paragraphs: [
        "Here’s a straightforward guide to how the pool works, what you fill in on each screen, and when your picks lock. Exact points can differ between tournaments, so always check Settings to see what applies in your game.",
      ],
    },
    {
      title: "What kind of game is this?",
      paragraphs: [
        "This is a shared tipping game where you and other players predict matches, group tables, and extra questions about the tournament.",
        "Whoever created the tournament decides how many points different things are worth — for example points for picking the match winner, the exact score, the right place in a group, or the overall winner.",
        "You don’t need to calculate points yourself. Once real results are entered, the app works out the scores automatically.",
      ],
    },
    {
      title: "Group stage",
      paragraphs: [
        "Under Group stage you predict every match by entering how many goals you think the home team scores and how many the away team scores.",
        "Depending on the tournament rules you can score for the right winner, a correct draw, or the exact final score.",
        "Your group-stage picks must be filled in before the group stage locks. The same applies to standings picks and extras (finalists, winner, top scorer).",
      ],
    },
    {
      title: "Knockout",
      paragraphs: [
        "Knockout works much the same way: you predict scores in the rounds of 16, quarters, semis and final, depending how the tournament is set up.",
        "Some knockout games may not show both teams at first. That’s because teams aren’t decided until earlier matches or groups are finished. Once the teams are known you can enter your picks.",
      ],
    },
    {
      title: "Standings",
      paragraphs: [
        "Under Standings you choose how you think teams finish in each group — usually who finishes 1st, 2nd and 3rd.",
        "Standings picks lock when the first group-stage match kicks off.",
        "These are separate picks from ordinary match scores. You can earn points both from individual matches and from how well you predict the final group order.",
        "Some tournaments also award points when you picked the right team but the wrong place. Check Settings for the exact rule.",
      ],
    },
    {
      title: "Extras",
      paragraphs: [
        "Under Extras there may be more to predict — finalists, tournament winner, top scorer, and similar.",
        "Extras lock when the first group-stage match kicks off.",
        "Those picks have their own points and are counted separately from matches and standings. For exact values, see Settings.",
        "Top-scorer rules can differ: sometimes only the actual golden boot earns a bonus, sometimes you get points for each goal by a player you chose.",
      ],
    },
    {
      title: "Overview",
      paragraphs: [
        "On Overview you see fixtures in date order — handy for seeing the whole schedule and what’s coming next.",
      ],
    },
    {
      title: "Leaderboards and comparisons",
      paragraphs: [
        "On the leaderboards you see how you rank against everyone else in the same tournament.",
        "There may also be views that show how others have tipped. That’s there for clarity and fun. Your score only depends on your own picks and the real results.",
      ],
    },
    {
      title: "Odds as a guide",
      paragraphs: [
        "On some matches you can show odds to help you tip. They roughly reflect how bookmakers or odds sources rate the game.",
        "Odds are only a guide. You’re not betting money in the app and odds don’t change how points are calculated.",
        "If odds are missing you can still tip manually, as long as the match isn’t locked.",
      ],
    },
    {
      title: "Harry Boy",
      paragraphs: [
        "Harry Boy is a shortcut that can fill in group-stage matches for you. It uses the score suggestions from the odds material and picks tips from that.",
        "It’s an easy way to get started if you don’t want to type every match yourself.",
        "Harry Boy only fills group-stage matches where there’s enough detail in the odds. If a match doesn’t have that, it skips it and you fill that match yourself.",
        "If you’ve already started a pick — for example only the home goals — Harry Boy can fill in what’s missing.",
      ],
    },
    {
      title: "Harry Boy’s modes",
      bullets: [
        "Low-scoring usually picks fewer goals, but may switch mode or a nearby score line.",
        "High-scoring usually picks more goals, with the same kind of variation.",
        "Safe usually picks the odds favourite, with the same kind of variation.",
        "Mix randomises the mode per match and varies the row within that mode.",
      ],
      paragraphs: [
        "Harry Boy doesn’t change standings picks, knockout picks, finalists, winner or top scorer — only group-stage matches.",
        "When the group stage is locked you can’t use Harry Boy anymore.",
      ],
    },
    {
      title: "Clearing and editing picks",
      paragraphs: [
        "You can change your picks until that part of the tournament locks.",
        "Where there’s a clear button you can remove your filled-in group-stage picks and start over.",
        "Once a section is locked nobody can change picks there — same for every player.",
      ],
    },
    {
      title: "When do picks lock?",
      paragraphs: [
        "Everyone in the same tournament follows the same lock times.",
        "The group stage locks when the first group-stage match kicks off. After that no one can change group-stage picks, standings picks, extras, or use Harry Boy for the group stage.",
        "Knockout has its own lock: knockout picks lock when the first knockout match kicks off. So you can still edit knockout picks after the group stage has started, as long as knockout hasn’t started yet.",
        "If a match doesn’t have both teams yet you can’t tip it until they’re known — that isn’t the same as the match being locked.",
      ],
    },
    {
      title: "Where do I see the points?",
      paragraphs: [
        "Points can look different in different tournaments. Open Settings in your tournament to see exactly what applies.",
        "There you’ll see how many points you get for match picks, standings picks, extras, finalists, winner, top scorer, and anything else the organiser chose.",
      ],
    },
  ],
};
